#### Application questionnaire input limits

We’ve tightened the byte limit on `String` input fields of the [`createApplicationQuestionnaire` mutation] from 2,048 to 255 bytes in UTF-8 encoding.
This aligns with the [default limit](/graphql/seek-api-conventions#string-lengths) for the SEEK API.

[`createapplicationquestionnaire` mutation]: /schema/mutation/createApplicationQuestionnaire
